import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    mobileMenu: false,
    subMobileMenu: false,
    microMobileMenu: false,
    currentSelectedSubMenu: null,
    currentSelectedMicroMenu: null,
    countries: [],
    states: [],
    cities: [],
  },
  mutations,
  actions,
  getters,
};
